import React from 'react'
import classNames from 'classnames'

import { Icon } from '@scentregroup/ui'

import { User } from '../types'

import style from './index.scss'
import Nav from '.'

const Account: React.FC<{
  user?: User
  onClose: () => void
}> = ({ user, onClose }) => {
  const items = user
    ? [
        () => (
          <div className={classNames(style.item, style['item-big'])}>
            {user.firstName ? `Hi, ${user.firstName}!` : 'Hi!'}
          </div>
        ),
        { label: 'Account', url: '/account' },
        { label: 'Orders', url: '/orders' },
        { label: 'Preferences', url: '/preferences' },
        () => <hr />,
        { label: 'Sign out', url: '/sign-out' },
      ]
    : [
        {
          label: 'Login',
          url: '/login',
          className: classNames(style['item-big']),
        },
        {
          label: 'Sign up',
          url: '/sign-up',
          className: classNames(style['item-big']),
        },
        { label: 'About Westfield Plus', url: '/about-westfield-plus' },
        () => (
          <>
            <div className={classNames(style.item, style.title)}>
              Members get more
            </div>
            <div className={classNames(style.item)}>
              <Icon
                size="small"
                type="tick"
                className={classNames(style.icon)}
              />
              <span>Free delivery options</span>
            </div>
            <div className={classNames(style.item)}>
              <Icon
                size="small"
                type="tick"
                className={classNames(style.icon)}
              />
              <span>10% back on Click &amp; Collect</span>
            </div>
            <div className={classNames(style.item)}>
              <Icon
                size="small"
                type="tick"
                className={classNames(style.icon)}
              />
              <span>Easy returns</span>
            </div>
          </>
        ),
      ]

  return (
    <Nav
      className={classNames(style['nav-reverse'])}
      items={items}
      onClose={onClose}
    />
  )
}

export default Account
